import React from 'react';
import PropTypes from 'prop-types';

import AbstractFunnel from "@components/abstract_funnel";
import withLoader from '@components/common/with_loader_decorator';
import withHistory from '@components/common/with_history_decorator'
import withPhoneCollector from '@components/common/with_phone_collector_decorator'
import Authenticator from '@components/common/authenticator'

import FunnelStatePersistance from '@services/funnel_state_persistance'

class AfterRenovationCleaningFunnel extends AbstractFunnel {
    static childContextTypes = {
        locationStrategy: PropTypes.string
    };

    componentDidMount() {
        if(this.props.initializeStateAndHistory){
            this.props.initializeStateAndHistory({ componentName: 'AfterRenovationCleaningFunnel', currentState: this.state });
        }
        FunnelStatePersistance.loadPersistedStateIfNeeded(this);
    }

    serviceType = () => {
        return 'after_renovation_cleaning';
    };

    availabilityPathString = () => {
        return 'after_renovation_cleaning_availability_path';
    };


    companiesForDatePath = () => {
        return PathHelper('companies_for_date_after_renovation_requests_path');
    };

    attributesPath = () => {
        return PathHelper('attributes_after_renovation_cleaning_requests_path');
    };

    extraServiceTypes = () => {
        return ['carpet_and_upholstery_cleaning', 'oven_cleaning']
    };
}


AfterRenovationCleaningFunnel = withLoader(AfterRenovationCleaningFunnel);
AfterRenovationCleaningFunnel = withPhoneCollector(AfterRenovationCleaningFunnel);
AfterRenovationCleaningFunnel = withHistory(AfterRenovationCleaningFunnel);

class AuthenticatingAfterRenovationCleaningFunnel extends React.Component {
    render() {
        return (
            <Authenticator status={this.props.componentProps.authenticationStatus}
                           omniauthError={this.props.componentProps.omniauthError}
                           component={AfterRenovationCleaningFunnel}
                           {...this.props} />
        );
    }
}

export default  AuthenticatingAfterRenovationCleaningFunnel;
